import React, { useState } from "react";
import { Tabs, Tab, Box } from '@mui/material';
import { HalfTimeTable } from "../pages/HalfTime/HalfTimeTable";
import { OverTable } from "../pages/Over/OverTable";
import { UnderTable } from "../pages/Under/UnderTable";
import { FriendlyTable } from "../pages/Friendly/FriendlyTable";

const Dashboard = () => {
    const [tab, setTab] = useState(0);

    return (
        <div>
            <h1>Webet</h1>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)}>
                    <Tab label="Over — Gol Adicional" />
                    <Tab label="Under — No pasa nada" />
                    <Tab label="Half Time" />
                    <Tab label="Amistosos" />
                </Tabs>
            </Box>
            <Box sx={{ pt: 2 }}>
                {tab === 0 && <OverTable />}
                {tab === 1 && <UnderTable />}
                {tab === 2 && <HalfTimeTable />}
                {tab === 3 && <FriendlyTable />}
            </Box>
        </div>
    );
}

export default Dashboard;
